// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"certificate-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 2L4 22L20 22L20 2L4 2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M8 2L12 2V7.5L10 6L8 7.5V2Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 13H16M8 17H14M12 2H8L8 7.5L10 6L12 7.5V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 2L4 22L20 22L20 2L4 2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Certificate1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'certificate-1',
    ref,
    icon: element,
  },
));

Certificate1Icon.displayName = 'Certificate1Icon';

export default Certificate1Icon;
